import { useEffect, useMemo, useState } from "react";
import { useCollectionData } from "react-firebase-hooks/firestore";
import {
  getCountFromServer,
  orderBy,
  query,
  where,
  limit,
} from "firebase/firestore";
import { getAcpExportsCollection } from "~/integrations/firebase/collections/acp-exports";
import { usePagination } from "./use-pagination";

export const useAcpExports = ({
  organisationId,
}: {
  organisationId: string;
}) => {
  const [itemsCount, setItemsCount] = useState(0);
  const { page, pageSize, setPage } = usePagination();

  const baseQuery = useMemo(
    () =>
      query(
        getAcpExportsCollection(),
        where("organisation.id", "==", organisationId),
        orderBy("createdAt", "desc"),
      ),
    [organisationId],
  );

  const from = (page - 1) * pageSize;
  const to = from + pageSize;

  const [exports = [], loading] = useCollectionData(
    query(baseQuery, limit(to)),
  );

  useEffect(() => {
    let active = true;
    const refreshCount = async () => {
      try {
        const snapshot = await getCountFromServer(baseQuery);
        const { count } = snapshot.data();
        if (active) setItemsCount(count);
      } catch {
        if (active) setItemsCount(0);
      }
    };

    refreshCount();
    return () => {
      active = false;
    };
  }, [baseQuery]);

  return {
    loading,
    exports: exports.slice(from, to),
    itemsCount,
    setPage,
  };
};
